import { BBDTag, Horizontal, Texto } from '@gravitate-js/excalibrr'
import { isDefined } from '@utils/general'
import { formatters } from '@utils/intl/dateTimeFormatters'
import { Col, Row } from 'antd'
import moment from 'moment'

export const DropDisplay = ({ index, drop, selectedTank, spanWidth, showWaterReading, unit, useInches, timezone }) => {
  if (!drop) return null
  const showStartReading = drop.start_volume || drop.start_inches
  const showEndReading = drop.end_volume || drop.end_inches
  return (
    <Row key={index} className='p-3 detail-row'>
      <Col align='left' span={3}>
        <Texto>{drop.store}</Texto>
      </Col>
      <Col align='left' span={3}>
        <Texto>{drop.product}</Texto>
      </Col>
      <Col align='left' span={3}>
        <BBDTag theme2 onClick={() => setEditingTank(true)}>
          {selectedTank ? (
            <Horizontal>
              {selectedTank.id} ({selectedTank.product})
            </Horizontal>
          ) : (
            'Select Tank'
          )}
        </BBDTag>
      </Col>
      <Col align='left' span={3}>
        <Texto>{formatters.DATE(moment(drop.date), timezone, true)}</Texto>
      </Col>
      <Col align='left' span={2}>
        <Texto>{formatters.TIME(moment(drop.time), timezone, true)}</Texto>
      </Col>
      <Col align='left' span={spanWidth} data-cy={`start-reading${index}`}>
        {showStartReading && (
          <Texto>{useInches ? `${drop.start_inches} (${unit})` : `${drop.start_volume} (${unit})`}</Texto>
        )}
      </Col>
      {showWaterReading && (
        <Col align='left' span={2} data-cy={`water-reading${index}`}>
          <Texto>{isDefined(drop.water_inches) ? `${drop.water_inches} (in)` : ''}</Texto>
        </Col>
      )}
      <Col align='left' span={spanWidth} data-cy={`end-reading${index}`}>
        {showEndReading && <Texto>{useInches ? `${drop.end_inches} (${unit})` : `${drop.end_volume} (${unit})`}</Texto>}
      </Col>
      <Col style={{ fontWeight: 600 }} align='left' span={spanWidth}>
        <Texto>{drop.quantity}</Texto>
      </Col>
      <Col span={1} align='right' />
    </Row>
  )
}
